import { render, staticRenderFns } from "./MultipleUsers.vue?vue&type=template&id=12b12cf2"
import script from "./MultipleUsers.vue?vue&type=script&lang=js"
export * from "./MultipleUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports